import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class SharedService {

	constructor(private router: Router) { }
	allowAlphabetsOnly(event: any) {
		var inp = String.fromCharCode(event.keyCode);
		if (/[a-zA-Z\s]/.test(inp)) {
			return true;
		} else {
			event.preventDefault();
			return false;
		}
	}

	allowNumbersOnly(event: any) {
		var inp = String.fromCharCode(event.keyCode);
		var inputField = event.target;
		if (/[0-9]/.test(inp) && inputField.value.length < 10) {
			return true;
		} else {
			event.preventDefault();
			return false;
		}
	}

	private secretKey = 'ABC9876543210Z';

	logout(): void {
		sessionStorage.clear();
		this.router.navigate(['/login']);
	  }

	encryptData(data: string): string {
		return CryptoJS.AES.encrypt(data, this.secretKey).toString();
	}

	decryptData(encryptedData: string): string {
		try {
		  const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
		  return bytes.toString(CryptoJS.enc.Utf8);
		} catch (error) {
		  console.error('Error decrypting data:', error);
		  return '';
		}
	  }
	  

	setSessionStorage(key: string, value: string): void {
		const encryptedValue = this.encryptData(value);
		sessionStorage.setItem(key, encryptedValue);
	  }
	
	  getSessionStorage(key: string): string | null {
		const encryptedValue = sessionStorage.getItem(key);
		return encryptedValue ? this.decryptData(encryptedValue) : null;
	  }

}
